// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"ConfirmationModal_body-text__2f-KO","icon":"ConfirmationModal_icon__1jUQl","topAlert":"ConfirmationModal_top-alert__QQdlE"};